import EditorSavePrompt from './editor-save-prompt';

export default EditorSavePrompt;
